package com.hyperether.goodjob.scenes.jobs

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.material.IconButton
import androidx.compose.material.Surface
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.painter.Painter
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.ic_back
import com.hyperether.goodjob.scenes.components.noRippleClickable
import com.hyperether.goodjob.util.toScaleDp
import org.jetbrains.compose.resources.painterResource

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun FullScreenImagePreview(imagePainter: Painter, onDismiss: () -> Unit) {
    Surface(
        color = Color.Black.copy(alpha = 0.7f),
    ) {
        Row(
            verticalAlignment = Alignment.CenterVertically,
            modifier = Modifier
                .fillMaxWidth()
                .padding(vertical = 10.toScaleDp(), horizontal = 20.toScaleDp())
                .height(48.toScaleDp())
        ) {
            Box(modifier = Modifier.weight(1f)) {
                IconButton(
                    modifier = Modifier.size(20.toScaleDp()),
                    onClick = { onDismiss() }
                ) {
                    Image(
                        painter = painterResource(Res.drawable.ic_back),
                        contentDescription = "",
                        modifier = Modifier.size(20.toScaleDp())
                    )
                }
            }
        }

        Box(
            modifier = Modifier.fillMaxSize()
                .noRippleClickable { onDismiss() }
                .pointerHoverIcon(PointerIcon.Hand)
        ) {
            Image(
                painter = imagePainter,
                contentDescription = null,
                modifier = Modifier
                    .heightIn(max = 500.toScaleDp())
                    .align(Alignment.Center)
                    .noRippleClickable {
                        //absorb click
                    }
                    .pointerHoverIcon(PointerIcon.Default)
            )
        }
    }
}